import styled from 'styled-components';
import { FontSize,ThemesColors} from '@themes/index';
import Sider from 'antd/es/layout/Sider';
import {Layout as AntLayout, Menu} from 'antd';


const AuthWrapper = styled.div`
  width: 100%;
  display: flex;
  background-color:${ThemesColors.mainBlueRGB}
  
`;


const DashboardLogoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 30px;
`



const DashboardTitle = styled.h1`
    color: ${ThemesColors.gray700};
    font-size: ${FontSize.ms};
    line-height: 26px;
`;



const SidebarContainer = styled(Sider)`
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px 0px;
    .ant-menu-light.ant-menu-root.ant-menu-inline{
        border:0;
    }
`;

const StyledMenu = styled(Menu)`
    width: 100%;
    border-right: none;
    .ant-menu-item-selected {
        background-color: ${ThemesColors.popoverBackground} !important;
    }
    .ant-menu-item-icon {
        font-size: 24px;
        margin-bottom: 8px;
    }
`;

const DashboardLogo = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 150px;
`



const HeaderOutletWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const DashboardCloseWrapper = styled.div`
    text-overflow: clip;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    height: 41px;
    border-top: 1px solid #FCFCFD;
    box-shadow: 0px 2px 8px 0px #00000026;
    width: 100%;
    padding-left: 8px;
    transition: all 0.3s;

`
const CloseSliderContainerClosed = styled(DashboardCloseWrapper)`
`;


const DashboardLayoutWrapper = styled(AntLayout)`
    min-height: 100vh !important;
`

const LogoTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    padding: 25px 25px 5px 25px;
`

const SearchFormWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 308px;
    margin-left: 10px;

`

const MobileLogo = styled.div`
    
      @media (max-width: 700px) {
           display:none;    
      }
`;
export {
    AuthWrapper,
    SearchFormWrapper,
    DashboardTitle,
    StyledMenu,
    SidebarContainer,
    DashboardLogo,
    DashboardLogoWrapper,
    HeaderOutletWrapper,
    CloseSliderContainerClosed,
    DashboardLayoutWrapper,
    LogoTitleWrapper,
    MobileLogo
};